module.exports = __webpack_public_path__ + "assets/flyt-icons_airport-pin.ad0293af.svg";